module.exports = __webpack_public_path__ + "img/title-5mg-m.8b386ee5.png";